import { LocalstorageService } from '../providers/localstorage.service';

export class RedirectRouteConstants {
    constructor() {}

    static getDefaultRoute() {
        const localStorageService = new LocalstorageService();
        let menuItems: any[] = [];

        try {
            menuItems = JSON.parse(localStorageService.getData('menuItems') || '[]');
        } catch (error) {
            menuItems = [];
        }

        const defaultRoute = menuItems.length > 0 ? menuItems[0]?.routerUrl : '/login';
        return defaultRoute;
    }
}

export const REDIRECT_URL = RedirectRouteConstants.getDefaultRoute();